export const portfolioData = {
  personal: {
    name: 'Suriyaprakash Somu',
    shortName: 'Suriyaprakash',
    role: 'Full-Stack Developer',
    tagline: 'Full-stack developer: React, Node.js and production backends',
    headline:
      'Full-stack engineering, built for production.',
    description:
      'Full-stack developer based in Erode, Tamil Nadu, building React and Node.js applications with access control, schema-driven forms and production backends. Also available for business websites and custom applications.',
    seoTitle: 'Suriyaprakash Somu | Full-Stack Developer (React, Node.js)',
    seoDescription:
      'Full-stack developer in Erode, India, building React and Node.js applications with access control and production backends. Open to full-time roles.',
    email: 'suriyaprakash_s@outlook.in',
    phone: '+91-9750110806',
    location: 'Erode, Tamil Nadu, India',
    availability:
      'Open to full-time, freelance and product build opportunities',
    resume: '/Suriyaprakash.pdf',
    image: '/image.webp',
    socials: [
      {
        platform: 'LinkedIn',
        url: 'https://www.linkedin.com/in/suriyaprakash-somu/',
        label: 'LinkedIn profile of Suriyaprakash Somu',
      },
      {
        platform: 'Twitter',
        url: 'https://x.com/sur1yaprakash',
        label: 'Twitter profile of Suriyaprakash',
      },
      {
        platform: 'GitHub',
        url: 'https://github.com/Suriyaprakash-Somu',
        label: 'GitHub profile of Suriyaprakash Somu',
      },
    ],
  },

  stats: [
    { value: '3+ years', label: 'professional full-stack experience' },
    {
      value: 'Full-stack',
      label: 'from customer-facing pages to internal tools',
    },
    {
      value: 'React + Node',
      label: 'TypeScript frontends with Express/Fastify and SQL backends',
    },
  ],

  works: [
    {
      id: 8,
      title: 'VetNest',
      year: '2026',
      type: 'Veterinary Website & Clinic Workflows',
      status: 'Live Demo',
      summary:
        'I designed and built a veterinary website and permission-aware admin platform connecting publishing, customer accounts, pets, appointment scheduling and billing.',
      problem:
        'A clinic needs a clear public website and controlled staff workflows without maintaining disconnected catalogues, profiles and customer records.',
      solution:
        'I built VetNest with TanStack Start, Xonava, Cloudflare D1 and R2, connecting rich-text publishing with a separate customer portal and staff workflows.',
      impact:
        'I brought content, clinic records and permissions together in one tested foundation, with scoped access, versioned edits and idempotent writes. The interactive demo uses fictional data.',
      stack: [
        'React',
        'TanStack Start',
        'Xonava',
        'Cloudflare Workers',
        'D1',
        'R2',
        'ABAC',
        'TypeScript',
      ],
      color: 'bg-sage-100',
      link: '/work/vetnest',
      liveUrl: 'https://vetnest.suriyaprakash.in',
    },
    {
      id: 1,
      title: 'IndianContext',
      year: '2025',
      type: 'Dynamic Editorial Website & CMS',
      status: 'Live',
      summary:
        'I built a dynamic editorial platform with articles, drafts, categories, series, media and a permission-aware publishing workspace.',
      problem:
        'Readers need clear discovery and thoughtful reading paths; editors need structured publishing, taxonomy, media and reusable management workflows.',
      solution:
        'I connected React, TanStack Start, CASL, schema-driven forms and Drizzle with Cloudflare Workers, D1 and R2.',
      impact:
        'I connected reading, content discovery and editorial operations through structured publishing workflows and reusable administration components.',
      stack: [
        'React',
        'TanStack Start',
        'Cloudflare D1',
        'Drizzle ORM',
        'RBAC',
        'ABAC',
        'Schema Forms',
        'Query Builder',
      ],
      color: 'bg-sage-100',
      link: '/work/indian-context',
      liveUrl: 'https://indiancontext.com',
    },
    {
      id: 2,
      title: 'My Clinic',
      year: '2025',
      type: 'Dynamic Healthcare Website',
      status: 'Live',
      summary:
        'I built a dynamic healthcare website connecting departments, physician profiles, service variants, health articles and patient contact paths.',
      problem:
        'Patients need understandable routes into care, whether they begin with a department, a doctor or a service, without guessing at the clinic structure.',
      solution:
        'I designed connected healthcare discovery pages and a dynamic service catalogue with categories, variants, durations and clear routes into contact.',
      impact:
        'I made a substantial care catalogue easier to explore through patient-oriented navigation, practical comparison details and consistent page structures.',
      stack: [
        'React',
        'Dynamic Content',
        'Service Catalogues',
        'Patient Navigation',
        'Healthcare UI',
      ],
      color: 'bg-cream-100',
      link: '/work/my-clinic',
      liveUrl: 'https://clinic.suriyaprakash.in',
    },
    {
      id: 3,
      title: 'PackCraft India',
      year: '2025',
      type: 'Interactive 3D Manufacturing Website',
      status: 'Live',
      summary:
        'I built an interactive packaging website with Three.js carton storytelling, product comparison, process pages and a contextual quote-interface prototype.',
      problem:
        'A packaging website needs a distinctive first impression without hiding the specifications, product choices and process information a buyer actually needs.',
      solution:
        'I combined React and Three.js with scroll-driven choreography, readable product routes and product intent carried into the quote interface.',
      impact:
        'I connected a distinctive 3D first impression to practical product discovery and a purposeful enquiry-interface design, backed by deterministic motion tests.',
      stack: [
        'React',
        'Cloudflare Workers',
        'Three.js',
        'TanStack Start',
        'Responsive Design',
        'Business Website',
      ],
      color: 'bg-sage-200',
      link: '/work/packcraft-india',
      liveUrl: 'https://carton.suriyaprakash.in',
    },
    {
      id: 4,
      title: 'ERP System',
      year: '2025',
      type: 'Enterprise Operations Platform',
      status: 'Private',
      summary:
        'A modular ERP system covering attendance, leave, purchase, inventory and production workflows.',
      problem:
        'Teams needed one reliable system to reduce manual tracking and connect daily operational processes.',
      solution:
        'Developed modules for facial-recognition attendance, leave management, purchase order processing, inventory, production design and role-based access control.',
      impact:
        'Centralized critical operations and reduced repeated manual coordination across departments.',
      stack: [
        'React',
        'Node.js',
        'Express',
        'MySQL',
        'RBAC',
        'Workflow Modules',
      ],
      color: 'bg-clay-100',
      link: null,
    },
    {
      id: 5,
      title: 'School Management System',
      year: '2024',
      type: 'Role-Based Admin Application',
      status: 'Private',
      summary:
        'A school operations system for student, staff, transport, fees and payroll administration.',
      problem:
        'School administrators needed a controlled system for sensitive records and role-specific workflows.',
      solution:
        'Implemented RBAC, management modules and structured data flows for multiple departments.',
      impact:
        'Streamlined school administration while keeping access permissions clear and maintainable.',
      stack: ['React', 'Express', 'MySQL', 'JWT', 'RBAC', 'Admin Workflows'],
      color: 'bg-stone-100',
      link: null,
    },
    {
      id: 6,
      title: 'Veterinarian Portfolio',
      year: '2024',
      type: 'Client Portfolio Website',
      status: 'Live Demo',
      summary:
        'A clean portfolio website presenting veterinary services, credibility and client contact paths.',
      problem:
        'The client needed a professional web presence that felt simple, credible and easy to navigate.',
      solution:
        'Created a responsive static portfolio with clear service sections, polished layout and direct calls to action.',
      impact:
        'Gave the client a presentable online identity suitable for sharing with potential customers.',
      stack: ['React', 'Vercel', 'Responsive Design'],
      color: 'bg-cream-200',
      link: 'https://vet-kappa.vercel.app/',
    },
    {
      id: 7,
      title: 'Payment Workflow Integration',
      year: '2024',
      type: 'Backend Reliability Work',
      status: 'Internal',
      summary:
        'Idempotent payment workflow integration for ticket-booking operations.',
      problem:
        'Payment flows needed protection against duplicate requests and inconsistent transaction states.',
      solution:
        'Integrated idempotency safeguards and backend workflow checks for more predictable payment processing.',
      impact:
        'Reduced duplicate transaction risk and improved operational confidence in payment handling.',
      stack: ['Node.js', 'Express', 'API Design', 'Payments'],
      color: 'bg-sage-50',
      link: null,
    },
  ],

  capabilities: [
    {
      title: 'Frontend Engineering',
      description:
        'Production-ready React and Next.js interfaces with reusable component libraries, schema-driven form rendering, dynamic data tables with sorting and filtering, and accessible admin dashboards for enterprise workflows.',
      skills: [
        'React',
        'Next.js',
        'TypeScript',
        'TanStack Form',
        'TanStack Query',
        'TanStack Table',
        'Zod',
      ],
    },
    {
      title: 'Backend & API Development',
      description:
        'RESTful API development with JWT-based authentication, RBAC and ABAC authorization via CASL, idempotent payment workflow integration, and maintainable server-side logic using modern Node.js frameworks.',
      skills: ['Node.js', 'Fastify', 'Express.js', 'JWT/JOSE', 'REST APIs'],
    },
    {
      title: 'Database Engineering & Access Control',
      description:
        'Relational database architecture (PostgreSQL, MySQL) with Drizzle ORM, role-based and attribute-based access control systems, permission-aware navigation, and data modeling for multi-tenant platforms.',
      skills: [
        'RBAC',
        'CASL',
        'PostgreSQL',
        'MySQL',
        'Drizzle ORM',
        'ERP Modules',
      ],
    },
    {
      title: 'Search & Query Architecture',
      description:
        'Visual query builders with nested AND/OR filter logic, search optimization, column sorting, paginated data retrieval, and backend query translation for complex business data exploration.',
      skills: [
        'QueryBuilder',
        'Drizzle Filters',
        'Search',
        'Sorting',
        'Pagination',
      ],
    },
    {
      title: 'Cloud Infrastructure & DevOps',
      description:
        'Cloudflare Workers and static site deployment, VPS and cPanel administration, Git-based CI/CD workflows, and Linux server management for production application delivery.',
      skills: ['Git', 'Linux', 'VPS', 'cPanel', 'Cloudflare'],
    },
  ],

  experience: [
    {
      role: 'Full Stack Developer',
      company: 'Kittle Pvt Ltd, Trichy',
      period: 'Oct 2023 - Present',
      highlights: [
        'Developed and deployed full-stack applications using React.js, Next.js, Node.js, Fastify, Express.js, PostgreSQL and MySQL.',
        'Built a custom role-based access control system for sensitive application workflows.',
        'Built schema-based form rendering with Zod metadata for reusable admin forms, validation, conditional fields and file/map inputs.',
        'Implemented dynamic query builder workflows with nested AND/OR filters, operator whitelisting and backend Drizzle filter translation.',
        'Integrated idempotent payment workflows to reduce duplicate transaction risk.',
      ],
    },
  ],

  outcomes: [
    'Built business applications across multi-tenant content platforms, ERP, school administration, publishing and payments.',
    'Designed reusable admin foundations with schema-based forms, dynamic query builders and TanStack-powered data workflows.',
    'Designed permission-aware workflows using RBAC, CASL abilities, secure authentication patterns and role-filtered navigation.',
    'Focused on maintainable code, practical UX and production-ready delivery.',
  ],

  services: [
    {
      title: 'Business website development',
      shortTitle: 'A better front door\nfor your business.',
      audience: 'For the people choosing you',
      description:
        'Turn what you do into a website people can understand, trust and act on. Clear services, useful product information and a direct path to getting in touch.',
      deliverables: [
        'Design shaped around your business, not a generic template',
        'Responsive pages with a clear content and search structure',
        'Enquiry paths that give visitors a useful next step',
      ],
      image: '/images/work/packcraft-india/homepage.jpg',
      imageAlt:
        'PackCraft India manufacturing website with interactive carton presentation',
      proof: 'PackCraft India · Manufacturing website',
      examples: 'Service websites · Product catalogues · Publishing platforms',
      project: '/work/packcraft-india',
      projectLabel: 'See the website case study',
    },
    {
      title: 'Custom web application development',
      shortTitle: 'Less working around tools.\nMore tools that fit.',
      audience: 'For the people doing the work',
      description:
        'When the work needs more than a website, I build the application behind it. Connect your records, give each person the right access and make everyday tasks easier to follow.',
      deliverables: [
        'Customer portals and staff tools built around real tasks',
        'Connected forms, records and day-to-day workflows',
        'Access rules enforced in the backend, not just the interface',
      ],
      image: '/images/work/vetnest/homepage.jpg',
      imageAlt:
        'Public website of the VetNest independent veterinary platform demo',
      proof: 'VetNest · Website + workflows · Independent demo',
      examples: 'Customer portals · Admin dashboards · Internal tools',
      project: '/work/vetnest',
      projectLabel: 'See the application case study',
    },
  ],

  contactCTA: {
    title: 'Have a project or an opportunity in mind?',
    subtitle:
      'Tell me about the website or application you want to build, or the developer role you are hiring for. Let us discuss how I could contribute.',
    buttonText: 'Email Suriyaprakash',
  },
}
